import { StyledAppCarousel } from './AppCarousel.styled';

const AppCarousel = ({ children, currentIndex = null }) => {
  return (
    <StyledAppCarousel $current={currentIndex}>
      {children && children.map((c, index) => (<div key={index} className='app-carousel-item'>{c}</div>))}
    </StyledAppCarousel>
  );
};

export default AppCarousel;
